import React from 'react';

import Market from '../Market';
import useTopMarkets from './useTopMarkets';

import './topMarkets.scss';

interface Props {
    sportEventId: string;
    count: number;
    withName: boolean;
}

const MARKET_ID_STUB = 'stub-market-id' as const;

const TopMarkets: React.FC<Props> = ({ sportEventId, count, withName }) => {
    let { topMarketIds } = useTopMarkets({ sportEventId });

    if (topMarketIds.count() === 0) {
        topMarketIds = topMarketIds.push(MARKET_ID_STUB);
    }

    return (
        <div styleName="container">
            {topMarketIds.slice(0, count).map(marketId => (
                <Market
                    key={marketId}
                    marketId={marketId}
                    withStub={marketId === MARKET_ID_STUB}
                    withName={withName}
                />
            ))}
        </div>
    );
};

export default React.memo(TopMarkets);
